import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentClear from 'material-ui/svg-icons/content/clear';
import Toggle from 'material-ui/Toggle';
import ChipInput from 'material-ui-chip-input';

import {
    Utils,
    paginaService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class Pagina extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            nome: '',
            paginaPublica: false,
            menu: false,
            url: '',
            dsNiveisAcesso: [],
            niveisAcessoSelecionados: [],
            isPosting: false,
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        const form = await paginaService.paginaForm();
        this.csrfToken = form.token;
        this.formId = form.formId;
        const { codigo } = this.props.match.params;
        if (codigo) {
            try {
                const dadosPagina = await paginaService.getPagina(codigo);
                this.setState({
                    editing: true,
                    nome: dadosPagina.pagina.NOME,
                    paginaPublica: dadosPagina.pagina.PAGINAPUBLICA,
                    menu: dadosPagina.pagina.MENU,
                    url: dadosPagina.pagina.URL,
                    niveisAcessoSelecionados: dadosPagina.niveisAcesso,
                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        }
        Utils.showLoading(false);
    }

    async onSave(event) {
        event.preventDefault();
        const {
            editing,
            nome,
            paginaPublica,
            menu,
            url,
            niveisAcessoSelecionados,
            isPosting,
        } = this.state;

        if (isPosting) {
            return;
        }

        this.setState({ isPosting: true });
        try {
            let response;
            if (editing) {
                response = await paginaService.update({
                    codigo: +this.props.match.params.codigo,
                    nome,
                    paginaPublica,
                    menu,
                    url,
                    niveisAcessoSelecionados,
                    _csrf: this.csrfToken,
                });
            } else {
                response = await paginaService.save({
                    nome,
                    paginaPublica,
                    menu,
                    url,
                    niveisAcessoSelecionados,
                    formId: this.formId,
                    _csrf: this.csrfToken,
                });
            }
            Utils.showToast(response.message);
            this.props.history.push('/paginas');
        } catch (error) {
            this.setState({ isPosting: false });
            Utils.showToast(error.message);
        }
    }

    async onGetNiveisAcesso(value) {
        if (!value) {
            return;
        }
        const niveisAcesso = await paginaService.getNiveisAcesso(value);
        this.setState({ dsNiveisAcesso: niveisAcesso });
    }

    render() {
        const {
            nome,
            paginaPublica,
            menu,
            url,
            isPosting,
            dsNiveisAcesso,
            niveisAcessoSelecionados,
        } = this.state;

        return (
            <PrincipalMaster title="Página" {...this.props}>
                <div>
                    <form onSubmit={e => this.onSave(e)}>
                        <div className="padding-content">
                            <TextField
                                name="nome"
                                floatingLabelText="Nome"
                                value={nome}
                                onChange={e => this.setState({ nome: e.target.value })}
                                errorText={nome ? '' : 'Campo obrigatório'}
                                fullWidth
                                required
                            />
                            <TextField
                                name="url"
                                floatingLabelText="URL"
                                value={url}
                                onChange={e => this.setState({ url: e.target.value })}
                                errorText={url ? '' : 'Campo obrigatório'}
                                fullWidth
                                required
                            />
                            <Toggle
                                toggled={paginaPublica}
                                labelPosition="right"
                                label="É página pública?"
                                onToggle={(e, checked) => this.setState({ paginaPublica: checked })}
                            />
                            <Toggle
                                toggled={menu}
                                labelPosition="right"
                                label="É menu?"
                                onToggle={(e, checked) => this.setState({ menu: checked })}
                            />
                            <ChipInput
                                value={niveisAcessoSelecionados}
                                newChipKeyCodes={[]}
                                fullWidth
                                disabled={paginaPublica}
                                floatingLabelText="Níveis de acesso"
                                onUpdateInput={value => this.onGetNiveisAcesso(value)}
                                dataSourceConfig={{ text: 'NOME', value: 'CODIGO' }}
                                dataSource={dsNiveisAcesso}
                                onRequestDelete={value => this.setState({ niveisAcessoSelecionados: niveisAcessoSelecionados.filter(x => x.CODIGO !== value) })}
                                onRequestAdd={nivelAcesso => this.setState({ niveisAcessoSelecionados: niveisAcessoSelecionados.concat(nivelAcesso) })}
                            />
                        </div>
                        <div className="fab-buttons">
                            <FloatingActionButton type="submit" disabled={isPosting} style={{ marginRight: 8 }}>
                                <ContentSave />
                            </FloatingActionButton>
                            <FloatingActionButton onClick={() => this.props.history.push('/paginas')} backgroundColor="rgb(100, 100, 100)">
                                <ContentClear />
                            </FloatingActionButton>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

Pagina.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            codigo: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default Pagina;
